import React from "react";

import { MetricKeys } from "@main/router/config/routePaths";
import EndpointHealthDataView from "main/pages/Release/views/MetricDetails/EndpointHealth/EndpointHealthDataView";
import NetworkSpeedDataView from "main/pages/Release/views/MetricDetails/NetworkSpeed/NetworkSpeedDataView";
import TestingCoverageDataView from "main/pages/Release/views/MetricDetails/TestingCoverage/TestingCoverageDataView";
import { useParams } from "react-router-dom";

export default function MetricDataView() {
  const { metricKey } = useParams<{ metricKey: string }>();

  if (metricKey === MetricKeys.endpointHealth) return <EndpointHealthDataView />;
  if (metricKey === MetricKeys.networkSpeed) return <NetworkSpeedDataView />;
  if (metricKey === MetricKeys.testingCoverage) return <TestingCoverageDataView />;

  return <></>;
}
